import { StatePrivacyPolicyCookieType, WbStatePrivacyCookieKey } from '../../components/common/interfaces/types';
import { getJsonCookieByKey } from './cookie';

/**
 * TODO: Remove after we final version of new privacy policy is deployed
 * Can only Remove at least weeks or months after new state privacy is deployed as
 * there can be existing cookies from users who have opted out of CCPA
*/

export const getCcpaCookie = () => {
    return getJsonCookieByKey('wb_ccpa');
};

export const getStatePrivacyPolicyCookie = (privacyPolicyCookieString: typeof WbStatePrivacyCookieKey = WbStatePrivacyCookieKey): StatePrivacyPolicyCookieType | null  => {
    return getJsonCookieByKey(privacyPolicyCookieString);
};
